/**
 * Learn more about theme events at
 * https://help.switchthemes.co/shapes/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
};

let cartDataIsStale = false;

window.addEventListener('shapes:cart:afteradditem', () => {
  cartDataIsStale = true;
});

document.addEventListener('shapes:cart:update', () => {
  cartDataIsStale = false;
});

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.dispatchEvent(
        new CustomEvent('shapes:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.addEventListener('cart-will-open', async () => {
  if (cartDataIsStale) {
    await new Promise((resolve) => {
      document.addEventListener('shapes:cart:unlock', resolve, { once: true });
      document.dispatchEvent(new CustomEvent('theme:update:cart'));
    });
  }

  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail,
    })
  );
});

document.addEventListener('cart-is-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail,
    })
  );
});

document.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);

document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

const captureShortsOfferEvent = (eventName, properties) => {
  if (window.posthog && typeof window.posthog.capture === 'function') {
    window.posthog.capture(eventName, properties);
  }
};

const shortsNudgeProperties = (nudgeEl, location) => ({
  state: nudgeEl.dataset.nudgeState || 'unknown',
  shorts_count: Number(nudgeEl.dataset.shortsCount) || 0,
  discount_cents: Number(nudgeEl.dataset.discountCents) || 0,
  location,
});

const trackShortsNudgeView = (nudgeEl, location, force = false) => {
  if (!nudgeEl || (!force && nudgeEl.dataset.rmNudgeViewTracked === 'true')) {
    return;
  }
  nudgeEl.dataset.rmNudgeViewTracked = 'true';
  captureShortsOfferEvent(
    'shorts_nudge_view',
    shortsNudgeProperties(nudgeEl, location)
  );
};

const visibleCartDrawerNudge = () => {
  const drawer = getCartDrawerEl();
  if (!drawer || window.getComputedStyle(drawer).display === 'none') return null;
  return drawer.querySelector('[data-rm-shorts-nudge]');
};

document.addEventListener('theme:cart-drawer:open', () => {
  trackShortsNudgeView(visibleCartDrawerNudge(), 'drawer', true);
});

document.addEventListener('theme:cart-drawer:closed', () => {
  const drawer = getCartDrawerEl();
  const nudge = drawer && drawer.querySelector('[data-rm-shorts-nudge]');
  if (nudge) delete nudge.dataset.rmNudgeViewTracked;
});

document.addEventListener('shapes:cart:update', () => {
  window.requestAnimationFrame(() => {
    trackShortsNudgeView(visibleCartDrawerNudge(), 'drawer');
  });
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.rm-shorts-nudge__link');
  if (!link) return;
  const nudge = link.closest('[data-rm-shorts-nudge]');
  captureShortsOfferEvent(
    'shorts_nudge_click',
    shortsNudgeProperties(nudge, nudge && nudge.closest('[data-cart-drawer]') ? 'drawer' : 'cart_page')
  );
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-rm-shorts-nudge]').forEach((nudge) => {
    if (!nudge.closest('[data-cart-drawer]')) {
      trackShortsNudgeView(nudge, 'cart_page');
    }
  });
});

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}
